import Vue from 'vue'
import Main from './main.vue'
// import { PopupManager } from 'element-ui/src/utils/popup'
// import { isVNode } from 'element-ui/src/utils/vdom'
let ToastConstructor = Vue.extend(Main)

let instance
let instances = []
let seed = 1

const Toast = function(options) {
  Toast.closeAll()
  if (Vue.prototype.$isServer) return
  options = options || {}
  if (typeof options === 'string') {
    options = {
      content: options
    }
  }
  // let userOnClose = options.onClose
  let id = 'toast_' + seed++

  // options.onClose = function() {
  //   Toast.close(id, userOnClose)
  // }
  instance = new ToastConstructor({
    data: options
  })
  instance.id = id
  //   if (isVNode(instance.content)) {
  //     instance.$slots.default = [instance.content]
  //     instance.content = null
  //   }
  instance.vm = instance.$mount()
  document.body.appendChild(instance.vm.$el)
  instance.vm.visible = true
  instance.dom = instance.vm.$el
  //   instance.dom.style.zIndex = PopupManager.nextZIndex()
  instances.push(instance)
  return instance.vm
}

// Toast.close = function(id, userOnClose) {
//   for (let i = 0, len = instances.length; i < len; i++) {
//     if (id === instances[i].id) {
//       if (typeof userOnClose === 'function') {
//         userOnClose(instances[i])
//       }
//       instances.splice(i, 1)
//       break
//     }
//   }
// }

Toast.closeAll = function() {
  for (let i = instances.length - 1; i >= 0; i--) {
    instances[i].close()
  }
}

export default Toast



// WEBPACK FOOTER //
// ./src/components/toast/index.js